import { render, staticRenderFns } from "./CMEditAccountMember.vue?vue&type=template&id=b4ada064&"
import script from "./CMEditAccountMember.vue?vue&type=script&lang=js&"
export * from "./CMEditAccountMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4ada064')) {
      api.createRecord('b4ada064', component.options)
    } else {
      api.reload('b4ada064', component.options)
    }
    module.hot.accept("./CMEditAccountMember.vue?vue&type=template&id=b4ada064&", function () {
      api.rerender('b4ada064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/accounts/CMEditAccountMember.vue"
export default component.exports